export const LOAD_ALL_PROSPECT = "LOAD_ALL_PROSPECT";

